import { render, staticRenderFns } from "./Goals.vue?vue&type=template&id=0fca2868&scoped=true&"
import script from "./Goals.vue?vue&type=script&lang=js&"
export * from "./Goals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca2868",
  null
  
)

/* custom blocks */
import block0 from "./Goals.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fca2868')) {
      api.createRecord('0fca2868', component.options)
    } else {
      api.reload('0fca2868', component.options)
    }
    module.hot.accept("./Goals.vue?vue&type=template&id=0fca2868&scoped=true&", function () {
      api.rerender('0fca2868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Goals.vue"
export default component.exports